import clsx from 'clsx';

interface KbdProps {
  children: React.ReactNode;
  className?: string;
}

function Kbd({ children, className }: KbdProps) {
  return (
    <kbd
      className={clsx(
        'border-default bg-surface-secondary text-copy-primary inline-flex h-6 min-w-[1.5rem] items-center justify-center rounded border px-1.5 font-mono text-xs',
        className,
      )}
    >
      {children}
    </kbd>
  );
}

export default Kbd;
